import React from 'react';
import { Box, Typography, Paper, Avatar } from '@mui/material';
import { People } from '@mui/icons-material';
import UserManagementTable from '../../components/admin/users/UserManagementTable';

const UserManagement = () => {
    return (
        <Box sx={{ p: 3 }}>
            {/* Header */}
            <Paper elevation={4} sx={{
                mb: 4,
                p: 4,
                borderRadius: 3,
                background: 'linear-gradient(135deg, #2196f3, #42a5f5)',
                color: 'white'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    <Avatar sx={{
                        background: 'rgba(255,255,255,0.2)',
                        backdropFilter: 'blur(10px)',
                        border: '3px solid rgba(255,255,255,0.3)',
                        width: 80,
                        height: 80
                    }}>
                        <People sx={{ fontSize: 40 }} />
                    </Avatar>
                    <Box>
                        <Typography variant="h3" fontWeight={800} sx={{ mb: 1 }}>
                            User Management
                        </Typography>
                        <Typography variant="h6" sx={{ opacity: 0.9 }}>
                            Manage user accounts, roles, and permissions
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.8, mt: 1 }}>
                            Monitor user activity and maintain system security
                        </Typography>
                    </Box>
                </Box>
            </Paper>

            {/* User Management Table */}
            <UserManagementTable />
        </Box>
    );
};

export default UserManagement;
